
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("c8BWz", function(module, exports) {
$parcel$export(module.exports, "EmptyTocItem", () => (parcelRequire("8Utl8")).EmptyTocItem);

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $a4TK8 = parcelRequire("a4TK8");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $6mKj3 = parcelRequire("6mKj3");


var $6mEZ3 = parcelRequire("6mEZ3");


var $5kjCz = parcelRequire("5kjCz");


var $JbVPK = parcelRequire("JbVPK");


var $bX5uj = parcelRequire("bX5uj");


var $e4o8D = parcelRequire("e4o8D");










var $7sObp = parcelRequire("7sObp");


var $d3Yd3 = parcelRequire("d3Yd3");

const $bae8eba0391a5294$var$TocSpan = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        const { prop: prop, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c81d4k",
            __cmplp.prop.outline === "true" || __cmplp.prop.display === "true" ? "_1e0c1nu9" : "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $bae8eba0391a5294$var$ItemAnchor = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "a" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c81d4k",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $bae8eba0391a5294$var$ListItem = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "li" : t2;
        const { listStyle: listStyle, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1vjxhb3": (0, $7sObp.default)(__cmplp.listStyle)
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_qtt8140o",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $bae8eba0391a5294$export$a51ac23f8f2bec4c = 'toc-item-body';
const $bae8eba0391a5294$export$d9f23a508df4a861 = (element, outline)=>{
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: "toc-item-body",
        "data-outline": element.outline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bae8eba0391a5294$var$TocSpan, {
        prop: {
            display: '',
            outline: outline
        }
    }, element.outline, " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bae8eba0391a5294$var$ItemAnchor, {
        href: element.link,
        onClick: ()=>(0, $d3Yd3.scrollToHeader)(element.link),
        "data-testid": $bae8eba0391a5294$export$a51ac23f8f2bec4c,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "toc-link"
    }, element.innerContent)));
};
const $bae8eba0391a5294$export$f21f23352126117a = 'list-style-toc-level-container';
const $bae8eba0391a5294$export$cac47b1ba5f92468 = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { children: children, prop: prop } = t0;
    const t1 = prop?.csslistindent;
    let t2;
    if ($[0] !== t1) {
        t2 = {
            paddingLeft: t1
        };
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children || $[3] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ul", {
            "data-testid": $bae8eba0391a5294$export$f21f23352126117a,
            style: t2
        }, children);
        $[2] = children;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
};
const $bae8eba0391a5294$export$6e7eafba84a66a80 = 'list-style-toc-item-container';
const $bae8eba0391a5294$export$9b4f02b15f3133b5 = (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { children: children, prop: prop, link: link } = t0;
    let listStyle;
    if (link === "toc-empty-item") listStyle = "none";
    else listStyle = prop?.cssliststyle ?? "default";
    let t1;
    if ($[0] !== children || $[1] !== listStyle) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bae8eba0391a5294$var$ListItem, {
            "data-testid": $bae8eba0391a5294$export$6e7eafba84a66a80,
            listStyle: listStyle
        }, children);
        $[0] = children;
        $[1] = listStyle;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
const $bae8eba0391a5294$export$7186da1cdf210be9 = 'flat-style-toc-item-container';
const $bae8eba0391a5294$export$127d6feb1b4cbb5f = (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "data-testid": $bae8eba0391a5294$export$7186da1cdf210be9,
            className: "toc-item-container"
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
const $bae8eba0391a5294$export$e63da11b221387fa = (prop)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            display: "true"
        };
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== prop.separator) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bae8eba0391a5294$var$TocSpan, {
            className: "toc-separator",
            prop: t0
        }, prop.separator);
        $[1] = prop.separator;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};



var $8Utl8 = parcelRequire("8Utl8");


var $7CLBv = parcelRequire("7CLBv");


var $6jPem = parcelRequire("6jPem");


var $7W8i8 = parcelRequire("7W8i8");


var $202oG = parcelRequire("202oG");

const $1091a8df710790c5$var$logger = (0, $7W8i8.getLogger)('table-of-contents');
const $1091a8df710790c5$export$bebd062f3d239910 = (macroNode, adf)=>{
    const minConfig = Math.max(1, parseInt(macroNode?.attrs?.parameters?.macroParams?.minLevel?.value) || 1);
    const maxConfig = Math.min(6, parseInt(macroNode?.attrs?.parameters?.macroParams?.maxLevel?.value) || 6);
    const macroParams = macroNode?.attrs?.parameters?.macroParams;
    const headingElements = [];
    const includeheaderregex = macroParams?.include?.value;
    const excludeheaderregex = macroParams?.exclude?.value;
    // Helper function to go through heading content
    // and test regular expression against texts from content
    function filterHeadingWithRegex(node) {
        if (!node?.content) return false;
        if (!includeheaderregex && !excludeheaderregex) return true;
        try {
            let includeRegex;
            if (includeheaderregex) includeRegex = new RegExp(includeheaderregex);
            let excludeRegex;
            if (excludeheaderregex) excludeRegex = new RegExp(excludeheaderregex);
            let fullHeaderString = '';
            for (const el of node?.content)fullHeaderString += el?.text || el?.attrs?.text || el?.attrs?.__confluenceMetadata?.contentTitle || '';
            if (includeRegex && !includeRegex.test(fullHeaderString)) return false;
            if (excludeRegex && excludeRegex.test(fullHeaderString)) return false;
        } catch (error) {
            $1091a8df710790c5$var$logger.error`@@@@@ Failed to handle regular expression - ${error}`;
        }
        return true;
    }
    // Hold a list of headers to look for duplicates
    // duplicated headers require an additional index/key which appends the link
    const headingsIds = new Set();
    // NOTE: ADFNode and ADFEntity share the same shape but ADFEntity allows for more keys
    let adfObject = adf;
    if (typeof adf === 'string') try {
        adfObject = JSON.parse(adf);
    } catch  {
    // Swallow the error as ADF format error handling is expected to be done earlier,
    // in the component that renders the entire content
    }
    // Create a reusable visitor collection that can handle both headings and extensions (LCMs)
    const createVisitors = ()=>({
            heading: (node)=>{
                if (filterHeadingWithRegex(node)) {
                    // init deep-copy node
                    const clone = (0, (/*@__PURE__*/$parcel$interopDefault($7CLBv)))(node);
                    clone.attrs = clone.attrs || {};
                    clone.attrs.id = (0, $202oG.getHeadingId)(clone, headingsIds);
                    if (node?.attrs?.level >= minConfig && node?.attrs?.level <= maxConfig) headingElements.push(clone);
                }
            },
            // Traverse into extension nodes (Legacy Content Macros) to find nested headings
            extension: (node)=>{
                const nestedContent = node?.attrs?.parameters?.nestedContent;
                if (nestedContent && typeof nestedContent === 'object') // Recursively traverse the nested content with the same visitors
                // This allows us to handle nested LCMs (LCMs within LCMs)
                (0, $6jPem.traverse)(nestedContent, createVisitors());
                return node;
            }
        });
    // Traverse through ADF and filter out nodes that doesn't belong in the TOC
    // Options includes (minLevel, maxLevel, includeheaderregex, excludeheaderrregex)
    (0, $6jPem.traverse)(adfObject || {}, createVisitors());
    return {
        className: `${macroParams?.class?.value || 'macro-core'} toc-macro conf-macro output-block`,
        cssliststyle: macroParams?.style?.value,
        csslistindent: macroParams?.indent?.value,
        separators: macroParams?.separator?.value,
        headerelements: headingElements,
        headerRange: [
            'H1',
            'H2',
            'H3',
            'H4',
            'H5',
            'H6'
        ].slice(minConfig - 1, maxConfig),
        hasbody: macroNode?.attrs.bodyType === 'none' ? 'false' : 'true',
        name: macroNode?.attrs?.extensionKey,
        structure: macroParams?.type?.value,
        outline: macroParams?.outline?.value,
        printable: macroParams?.printable?.value || 'true',
        macroId: macroNode?.attrs?.parameters?.macroMetadata?.macroId?.value
    };
};






var $79mJ9 = parcelRequire("79mJ9");




function $3c658fd5408d21d0$export$9610d4f5b4c2681a(elementsArray, parentOutline = [], cloudId, userId) {
    if (elementsArray.length === 0) return null;
    const highestElementPrecedence = elementsArray.map((el)=>el?.attrs?.level).reduce(function(a, b) {
        return Math.min(a, b);
    });
    // Make sure the first element in the list matches the highest precedence level
    if (elementsArray[0]?.attrs?.level !== highestElementPrecedence) elementsArray.unshift({
        type: 'toc',
        attrs: {
            level: highestElementPrecedence
        },
        content: [
            {
                text: (0, $8Utl8.EmptyTocItem),
                type: 'string',
                innerHTML: ''
            }
        ]
    });
    const currentList = [];
    const subListBuffer = {
        subElements: [],
        currentItem: {
            innerContent: null,
            link: '',
            outline: [],
            children: null
        },
        outline: undefined,
        flush () {
            // eslint-disable-next-line react/prefer-stateless-function
            if (subListBuffer.subElements.length > 0 && subListBuffer.currentItem) {
                subListBuffer.currentItem.children = $3c658fd5408d21d0$export$9610d4f5b4c2681a(subListBuffer.subElements, subListBuffer.outline, cloudId, userId);
                subListBuffer.subElements = [];
            }
        },
        add (element) {
            subListBuffer.subElements.push(element);
        },
        resetItem (currentOutlineItem) {
            subListBuffer.outline = (parentOutline || []).slice(0);
            subListBuffer.outline.push(currentOutlineItem);
            subListBuffer.currentItem = {
                innerContent: null,
                link: '',
                outline: [],
                children: null
            };
            currentList.push(subListBuffer.currentItem);
            return subListBuffer.currentItem;
        }
    };
    let outlineCounter = 0;
    elementsArray.forEach(function(element) {
        if (element?.attrs?.level === highestElementPrecedence) {
            outlineCounter++;
            subListBuffer.flush();
            subListBuffer.resetItem(outlineCounter);
            if (element.content?.[0]?.text !== (0, $8Utl8.EmptyTocItem) && subListBuffer.currentItem) {
                const style = $3c658fd5408d21d0$var$createSSRTocItemBody(element, cloudId, userId, subListBuffer.outline?.join('.'));
                subListBuffer.currentItem.innerContent = style.linkText;
                subListBuffer.currentItem.link = style.linkHref;
                subListBuffer.currentItem.outline = style.outline ? [
                    style.outline
                ] : [];
            } else {
                subListBuffer.currentItem.innerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null);
                subListBuffer.currentItem.link = (0, $8Utl8.EmptyTocItem);
            }
        } else subListBuffer.add(element);
    });
    subListBuffer.flush();
    return currentList;
}
/**
 *
 * @param obj
 * @param outline
 * Creates an HTML element representing a single item in the TOC, including outline level and a link.
 */ function $3c658fd5408d21d0$var$createSSRTocItemBody(obj, cloudId, userId, outline) {
    return {
        outline: outline,
        linkHref: `#${encodeURIComponent(obj?.attrs?.id)}`,
        linkText: $3c658fd5408d21d0$var$getTextsFromElements(obj.content || [], cloudId, userId)
    };
}
/*
 ** Accumulates the texts from elements into a single header
 */ function $3c658fd5408d21d0$var$getTextsFromElements(contentArray, cloudId, userId) {
    if (!contentArray) return null;
    // Usage for mini-renderer
    // This is necessary as TOC runs into a race condition if we simply inject rendered results from the DOM
    // Because of async components that contain headers, ADF may not have sufficient content to render everything
    // We need to decide whether or not it is necessary to render injected output thereafter
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $79mJ9.MiniRenderer), {
        adfEntities: contentArray,
        cloudId: cloudId,
        userId: userId
    });
}












var $aXWIB = parcelRequire("aXWIB");


var $9wGTI = parcelRequire("9wGTI");


var $3jwuS = parcelRequire("3jwuS");





function $8abacf7de2a86dda$var$getInitialSeparator(ref) {
    if (ref.current === true) {
        ref.current = false;
        return true;
    } else return false;
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8abacf7de2a86dda$var$EmptyContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8fhey _syazi7uo",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $8abacf7de2a86dda$var$i18n = (0, $aXWIB.defineMessages)({
    emptyToc: {
        id: "table-of-contents.empty-toc",
        defaultMessage: "Add headings to this page and they\u2019ll instantly appear here."
    },
    livePageEmptyToc: {
        id: "table-of-contents.live-page-empty-toc",
        defaultMessage: "Add headings to this doc and they\u2019ll instantly appear here."
    }
});
const $8abacf7de2a86dda$export$1199a72d11f104e4 = (t0)=>{
    const $ = (0, $frIzR.c)(44);
    const { elementsArray: elementsArray, elementFactory: elementFactory, config: config, separators: separators, initialSeparatorRef: initialSeparatorRef, isInEditMode: isInEditMode } = t0;
    const intl = (0, $aXWIB.useIntl)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    if (!elementsArray) {
        if (isInEditMode) {
            let t1;
            if ($[0] !== intl || $[1] !== isLivePage) {
                let t2;
                if ($[3] !== isLivePage) {
                    t2 = isLivePage && (0, $9wGTI.fg)("confluence_live_pages_open_beta_trait_opted_in") ? $8abacf7de2a86dda$var$i18n.livePageEmptyToc : $8abacf7de2a86dda$var$i18n.emptyToc;
                    $[3] = isLivePage;
                    $[4] = t2;
                } else t2 = $[4];
                t1 = intl.formatMessage(t2);
                $[0] = intl;
                $[1] = isLivePage;
                $[2] = t1;
            } else t1 = $[2];
            let t2;
            if ($[5] !== t1) {
                t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8abacf7de2a86dda$var$EmptyContainer, null, t1);
                $[5] = t1;
                $[6] = t2;
            } else t2 = $[6];
            return t2;
        } else {
            let t1;
            if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
                t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null);
                $[7] = t1;
            } else t1 = $[7];
            return t1;
        }
    }
    let t1;
    if ($[8] !== elementFactory) {
        t1 = elementFactory.createTocLevelContainer();
        $[8] = elementFactory;
        $[9] = t1;
    } else t1 = $[9];
    const ElementsContainer = t1;
    let t2;
    if ($[10] !== elementFactory) {
        t2 = elementFactory.createTocItemContainer();
        $[10] = elementFactory;
        $[11] = t2;
    } else t2 = $[11];
    const ItemContainer = t2;
    if (config.structure === "flat") {
        let T0;
        let t3;
        let t4;
        if ($[12] !== ElementsContainer || $[13] !== config || $[14] !== elementsArray || $[15] !== initialSeparatorRef || $[16] !== separators?.[0] || $[17] !== separators?.[1] || $[18] !== separators?.[2]) {
            function buildFlatSubtree(subArray) {
                return subArray.map((element)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), {
                        key: element.outline
                    }, element.link !== (0, $8Utl8.EmptyTocItem) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                        className: "toc-separator"
                    }, $8abacf7de2a86dda$var$getInitialSeparator(initialSeparatorRef) ? separators?.[0] : separators?.[1]), $8abacf7de2a86dda$var$createTocItemBodyComponent(element, config.outline)) : null, element.children ? buildFlatSubtree(element.children) : null));
            }
            T0 = ElementsContainer;
            t3 = config;
            t4 = elementsArray.map((element_0, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), {
                    key: idx
                }, element_0.link !== (0, $8Utl8.EmptyTocItem) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                    className: "toc-separator"
                }, $8abacf7de2a86dda$var$getInitialSeparator(initialSeparatorRef) ? separators?.[0] : separators?.[1]), $8abacf7de2a86dda$var$createTocItemBodyComponent(element_0, config.outline)) : null, element_0.children ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, buildFlatSubtree(element_0.children)) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                    className: "toc-separator"
                }, idx === elementsArray.length - 1 ? separators?.[2] : null)));
            $[12] = ElementsContainer;
            $[13] = config;
            $[14] = elementsArray;
            $[15] = initialSeparatorRef;
            $[16] = separators?.[0];
            $[17] = separators?.[1];
            $[18] = separators?.[2];
            $[19] = T0;
            $[20] = t3;
            $[21] = t4;
        } else {
            T0 = $[19];
            t3 = $[20];
            t4 = $[21];
        }
        let t5;
        if ($[22] !== T0 || $[23] !== t3 || $[24] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
                prop: t3
            }, t4);
            $[22] = T0;
            $[23] = t3;
            $[24] = t4;
            $[25] = t5;
        } else t5 = $[25];
        return t5;
    }
    if (elementsArray) {
        let t3;
        if ($[26] !== ItemContainer || $[27] !== config || $[28] !== elementFactory || $[29] !== elementsArray || $[30] !== initialSeparatorRef || $[31] !== separators) {
            let t4;
            if ($[33] !== ItemContainer || $[34] !== config || $[35] !== elementFactory || $[36] !== initialSeparatorRef || $[37] !== separators) {
                t4 = (element_1)=>{
                    if (element_1.innerContent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, element_1.link !== (0, $8Utl8.EmptyTocItem) || element_1?.children ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ItemContainer, {
                        link: element_1.link,
                        prop: config,
                        key: element_1?.outline
                    }, element_1.link !== (0, $8Utl8.EmptyTocItem) ? $8abacf7de2a86dda$var$createTocItemBodyComponent(element_1, config.outline) : null, element_1.children ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8abacf7de2a86dda$export$1199a72d11f104e4, {
                        elementsArray: element_1.children,
                        elementFactory: elementFactory,
                        config: config,
                        separators: separators,
                        initialSeparatorRef: initialSeparatorRef,
                        isInEditMode: false
                    }) : null) : null);
                    else return null;
                };
                $[33] = ItemContainer;
                $[34] = config;
                $[35] = elementFactory;
                $[36] = initialSeparatorRef;
                $[37] = separators;
                $[38] = t4;
            } else t4 = $[38];
            t3 = elementsArray.map(t4);
            $[26] = ItemContainer;
            $[27] = config;
            $[28] = elementFactory;
            $[29] = elementsArray;
            $[30] = initialSeparatorRef;
            $[31] = separators;
            $[32] = t3;
        } else t3 = $[32];
        let t4;
        if ($[39] !== ElementsContainer || $[40] !== config || $[41] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ElementsContainer, {
                prop: config
            }, t3);
            $[39] = ElementsContainer;
            $[40] = config;
            $[41] = t3;
            $[42] = t4;
        } else t4 = $[42];
        return t4;
    }
    let t3;
    if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "Empty-TOC"
        });
        $[43] = t3;
    } else t3 = $[43];
    return t3;
};
/**
 *
 * @param element
 * @param displayOutline
 *
 * Build the Inner item body for TOC
 *
 */ function $8abacf7de2a86dda$var$createTocItemBodyComponent(element, displayOutline) {
    return (0, $bae8eba0391a5294$export$d9f23a508df4a861)(element, displayOutline);
}












var $31HPn = parcelRequire("31HPn");

const $8e0e4b45677b9150$export$595f30d6a02162ab = (adf, isInEditMode)=>{
    const $ = (0, $frIzR.c)(3);
    const [currentAdf, setCurrentAdf] = (0, $42omo.useState)(adf);
    let t0;
    let t1;
    if ($[0] !== isInEditMode) {
        t0 = ()=>{
            if (!isInEditMode) {
                const onForgeDocUpdated = (event)=>$8e0e4b45677b9150$export$5aa9e1e60a480751(event, setCurrentAdf);
                document.addEventListener((0, $31HPn.FORGE_DOC_UPDATED_EVENT), onForgeDocUpdated);
                return ()=>document.removeEventListener((0, $31HPn.FORGE_DOC_UPDATED_EVENT), onForgeDocUpdated);
            }
        };
        t1 = [
            isInEditMode
        ];
        $[0] = isInEditMode;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $42omo.useEffect)(t0, t1);
    return isInEditMode ? adf : currentAdf;
};
const $8e0e4b45677b9150$export$5aa9e1e60a480751 = (event, setAdf)=>{
    const { forgeDoc: forgeDoc, localId: localId } = event.detail;
    setAdf((prevAdf)=>{
        let adfObject = prevAdf;
        if (typeof prevAdf === 'string') try {
            adfObject = JSON.parse(prevAdf);
        } catch (_err) {
            // Swallow the error as ADF format error handling is expected to be done earlier,
            // in the component that renders the entire content
            return prevAdf;
        }
        const newAdf = (0, $6jPem.traverse)(adfObject, {
            // Match the triggering macro's localId in the ADF and update the macro content
            bodiedExtension: (node)=>{
                if (node.attrs?.localId === localId) {
                    const newContent = forgeDoc?.children?.[0]?.props?.document?.content;
                    if (newContent) node.content = newContent;
                    return node;
                }
            }
        });
        if (newAdf) return newAdf;
        return prevAdf;
    });
};


const $3c9bbcd4bd01fb6c$export$cd8f8ae5a1332c1a = 'non-printable-wrapper'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3c9bbcd4bd01fb6c$var$NonPrintableWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1reo1wug _18m91wug _ryw0idpf _1b33idpf _24zuglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $3c9bbcd4bd01fb6c$export$387c7b71086d6280 = 'printable-wrapper'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3c9bbcd4bd01fb6c$var$PrintableWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1reo1wug _18m91wug _ryw0idpf _1b33idpf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
function $3c9bbcd4bd01fb6c$export$eccbcf752b159ac1(separator) {
    switch(separator){
        case 'braces':
            return [
                '{ ',
                ' } { ',
                ' }'
            ];
        case 'pipe':
            return [
                '',
                ' | ',
                ''
            ];
        case 'parens':
            return [
                '( ',
                ' ) ( ',
                ' )'
            ];
        case '':
        case 'brackets':
            // brackets in the ADF is an empty string
            return [
                '[ ',
                ' ] [ ',
                ' ]'
            ];
        default:
            // Match separator usage for custom separators
            return [
                '',
                separator,
                ''
            ];
    }
}
const $3c9bbcd4bd01fb6c$var$TableOfContentsContainer = ({ cloudId: cloudId, userId: userId, adf: adf, macroDefaultProps: macroDefaultProps, isInEditMode: isInEditMode = false })=>{
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { node: node, mode: mode, contentId: contentId, extensionKey: extensionKey } = macroDefaultProps;
    const currentAdf = (0, $8e0e4b45677b9150$export$595f30d6a02162ab)(adf, isInEditMode);
    const macroNode = (0, $42omo.useMemo)(()=>(0, $6mEZ3.extensionToADF)(node), [
        node
    ]);
    const tocOptions = (0, $42omo.useMemo)(()=>(0, $1091a8df710790c5$export$bebd062f3d239910)(macroNode, currentAdf), [
        macroNode,
        currentAdf
    ]);
    const name = (0, $5kjCz.getExperienceName)(mode, node);
    const ElementFactory = (0, $42omo.useMemo)(()=>tocOptions.structure === 'flat' ? $3c9bbcd4bd01fb6c$var$flatTocElementFactory() : $3c9bbcd4bd01fb6c$var$listTocElementFactory(), [
        tocOptions.structure
    ]);
    const separators = (0, $42omo.useMemo)(()=>$3c9bbcd4bd01fb6c$export$eccbcf752b159ac1(tocOptions.separators || ''), [
        tocOptions.separators
    ]);
    const initialSeparatorRef = (0, $42omo.useMemo)(()=>({
            current: true
        }), []);
    initialSeparatorRef.current = true;
    const [preseparator, midseparator, postseparator] = separators;
    const flatSeparators = (0, $42omo.useMemo)(()=>tocOptions.structure === 'flat' ? {
            'data-preseparator': preseparator,
            'data-midseparator': midseparator,
            'data-postseparator': postseparator
        } : {}, [
        tocOptions.structure,
        preseparator,
        midseparator,
        postseparator
    ]);
    const { elementsArray: elementsArray, error: error_0 } = (0, $42omo.useMemo)(()=>{
        try {
            return {
                elementsArray: (0, $3c658fd5408d21d0$export$9610d4f5b4c2681a)(tocOptions.headerelements, [], cloudId, userId),
                error: null
            };
        } catch (error) {
            return {
                elementsArray: null,
                error: error
            };
        }
    }, [
        tocOptions?.headerelements,
        cloudId,
        userId
    ]);
    const reducedDomContent = (0, $6mKj3.expVal)('confluence_toc_reduce_dom_nodes', 'isEnabled', false) ? (0, $8Utl8.renderReducedToc)(tocOptions, separators, cloudId, userId) : null;
    if (error_0) {
        const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(node);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $JbVPK.MacroExperienceFailure), {
            name: name,
            contentId: contentId,
            extensionKey: extensionKey,
            mode: mode,
            error: error_0 || new Error(`${extensionKey} failed to render`),
            attributes: attributes,
            source: "TableOfContents"
        });
    }
    const tocContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: tocOptions.className,
        "data-numberedoutline": tocOptions.outline,
        "data-cssliststyle": tocOptions.cssliststyle,
        "data-csslistindent": tocOptions.csslistindent,
        "data-headerelements": tocOptions.headerRange,
        "data-hasbody": tocOptions.hasbody,
        "data-macro-name": tocOptions.name,
        "data-macro-id": tocOptions.macroId,
        "data-structure": tocOptions.structure,
        "data-vc": "toc",
        ...flatSeparators,
        ...renderServerPlaceholder ? {
            'data-ssr-placeholder': `toc-${tocOptions.macroId}`
        } : {
            'data-ssr-placeholder-replace': `toc-${tocOptions.macroId}`
        }
    }, reducedDomContent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8abacf7de2a86dda$export$1199a72d11f104e4), {
        elementsArray: elementsArray,
        elementFactory: ElementFactory,
        config: tocOptions,
        separators: separators,
        initialSeparatorRef: initialSeparatorRef,
        isInEditMode: isInEditMode
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: name,
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode
    })); // Wrap tocContent for printable:
    let Wrapper;
    let wrapperTestId;
    let wrapperVc;
    if (tocOptions.printable === 'false') {
        Wrapper = $3c9bbcd4bd01fb6c$var$NonPrintableWrapper;
        wrapperTestId = $3c9bbcd4bd01fb6c$export$cd8f8ae5a1332c1a;
        wrapperVc = 'non-printable-toc-wrapper';
    } else {
        Wrapper = $3c9bbcd4bd01fb6c$var$PrintableWrapper;
        wrapperTestId = $3c9bbcd4bd01fb6c$export$387c7b71086d6280;
        wrapperVc = 'printable-toc-wrapper';
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Wrapper, {
        title: "Macro (toc)",
        "data-fabric-macro": tocOptions.macroId,
        "data-macro-body": true,
        "data-macro-parameters": JSON.stringify(macroNode?.attrs?.parameters?.macroParams),
        "data-testid": wrapperTestId,
        "data-vc": wrapperVc,
        ...renderServerPlaceholder ? {
            'data-ssr-placeholder': tocOptions.macroId
        } : {
            'data-ssr-placeholder-replace': tocOptions.macroId
        }
    }, tocContent);
};
/**
 * Creates HTML elements for use in building a flat-style TOC
 */ function $3c9bbcd4bd01fb6c$var$flatTocElementFactory() {
    return {
        createTocLevelContainer () {
            return 0, $bae8eba0391a5294$export$127d6feb1b4cbb5f;
        },
        createTocItemContainer () {
            return 0, $bae8eba0391a5294$export$127d6feb1b4cbb5f;
        },
        decorateToc () {
            return true;
        }
    };
} /**
   * Creates HTML elements for use in building a list-style TOC
   */ 
function $3c9bbcd4bd01fb6c$var$listTocElementFactory() {
    return {
        createTocLevelContainer () {
            return 0, $bae8eba0391a5294$export$cac47b1ba5f92468;
        },
        createTocItemContainer () {
            return 0, $bae8eba0391a5294$export$9b4f02b15f3133b5;
        }
    };
}
const $3c9bbcd4bd01fb6c$export$65a20d5539dff777 = /*#__PURE__*/ (0, $42omo.memo)((0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($3c9bbcd4bd01fb6c$var$TableOfContentsContainer), (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
module.exports["nonPrintableWrapperTestId"] = $3c9bbcd4bd01fb6c$export$cd8f8ae5a1332c1a;
module.exports["printableWrapperTestId"] = $3c9bbcd4bd01fb6c$export$387c7b71086d6280;
module.exports["getSeparators"] = $3c9bbcd4bd01fb6c$export$eccbcf752b159ac1;
module.exports["TableOfContents"] = $3c9bbcd4bd01fb6c$export$65a20d5539dff777;

});

parcelRegister("JbVPK", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $98aa426b73cdcfeb$export$e394c7ce8301e00f({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, error: error, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
            name: name,
            attributes: {
                ...attributes,
                source: source
            },
            error: error
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        error,
        mode,
        name,
        source
    ]);
    return children;
}
module.exports["MacroExperienceFailure"] = $98aa426b73cdcfeb$export$e394c7ce8301e00f;

});

parcelRegister("e4o8D", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $1NBp8 = parcelRequire("1NBp8");


var $60cDW = parcelRequire("60cDW");

const $2679ebd914f0a083$var$emptySubscribe = ()=>()=>{};
const $2679ebd914f0a083$var$getClientSnapshot = ()=>false;
const $2679ebd914f0a083$var$getServerSnapshot = ()=>true;
const $2679ebd914f0a083$var$editRoutes = [
    (0, $1NBp8.EDIT_PAGE_V2),
    (0, $1NBp8.EDIT_BLOG_V2),
    (0, $1NBp8.EDIT_PAGE),
    (0, $1NBp8.EDIT_BLOG),
    (0, $1NBp8.EDIT_PAGE_EMBED)
];
const $2679ebd914f0a083$var$isEditOrLiveRoute = ()=>{
    const { uri: uri, isLivePage: isLivePage } = (0, $60cDW.getSSRRenderInputs)();
    if (isLivePage) return true;
    if (uri) return $2679ebd914f0a083$var$editRoutes.some((route)=>route.match(uri));
    return false;
};
const $2679ebd914f0a083$export$96e8e9e8e57310bb = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const renderServerPlaceholderOnNonHydrate = t0 === undefined ? false : t0;
    const isSSRSync = (0, $42omo.useSyncExternalStore)($2679ebd914f0a083$var$emptySubscribe, $2679ebd914f0a083$var$getClientSnapshot, $2679ebd914f0a083$var$getServerSnapshot);
    const optimizedRenderServerPlaceholder = (0, $42omo.useDeferredValue)(isSSRSync);
    const isTransition = window.__SSR_RENDERED__ === false;
    const [renderServerPlaceholder, setRenderServerPlaceholder] = (0, $42omo.useState)(renderServerPlaceholderOnNonHydrate ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            if ($2679ebd914f0a083$var$isEditOrLiveRoute() || !(0, $6mKj3.expVal)("confluence_optimize_render_server_placeholder", "isEnabled", false)) setRenderServerPlaceholder(false);
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[2] !== optimizedRenderServerPlaceholder || $[3] !== renderServerPlaceholder) {
        t3 = !$2679ebd914f0a083$var$isEditOrLiveRoute() && (0, $6mKj3.expVal)("confluence_optimize_render_server_placeholder", "isEnabled", false) ? optimizedRenderServerPlaceholder : renderServerPlaceholder;
        $[2] = optimizedRenderServerPlaceholder;
        $[3] = renderServerPlaceholder;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
};
module.exports["useRenderServerPlaceholder"] = $2679ebd914f0a083$export$96e8e9e8e57310bb;

});

parcelRegister("4CRRu", function(module, exports) {

let $35e47dd6a2ff201b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $35e47dd6a2ff201b$var$load("3ioZJ").then(()=>parcelRequire('5vSwz'));

});

parcelRegister("bCNu1", function(module, exports) {

let $8769a0a23499456a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8769a0a23499456a$var$load("dkgtP"),
    $8769a0a23499456a$var$load("g43Ev"),
    $8769a0a23499456a$var$load("iTmpz")
]).then(()=>parcelRequire('l5vdF'));

});

parcelRegister("aaCOu", function(module, exports) {

let $7678f217fda4e404$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7678f217fda4e404$var$load("8OJBc").then(()=>parcelRequire('hqnQO'));

});

parcelRegister("13jdz", function(module, exports) {

let $0c44fa8855615511$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0c44fa8855615511$var$load("hhss7"),
    $0c44fa8855615511$var$load("Wowvf"),
    $0c44fa8855615511$var$load("fDwDZ")
]).then(()=>parcelRequire('2I7c2'));

});

parcelRegister("7CLBv", function(module, exports) {

var $ipwYn = parcelRequire("ipwYn");

/** Used to compose bitmasks for cloning. */ var $58d10224aec51c86$var$CLONE_DEEP_FLAG = 1, $58d10224aec51c86$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $58d10224aec51c86$var$cloneDeep(value) {
    return $ipwYn(value, $58d10224aec51c86$var$CLONE_DEEP_FLAG | $58d10224aec51c86$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $58d10224aec51c86$var$cloneDeep;

});

parcelRegister("202oG", function(module, exports) {

var $h9yJL = parcelRequire("h9yJL");

function $2cfd9ea7d82f1add$export$dbad71934afee167(node, headingIds) {
    if (!node?.content?.length) return;
    // We are not use node.textContent here, because we would like to handle cases where
    // headings only contain inline blocks like emoji, status and date.
    const nodeContent = node.content.reduce((acc, currentNode)=>acc.concat($2cfd9ea7d82f1add$var$getText(currentNode) || ''), '').trim().replace(/\s/g, '-');
    if (!nodeContent) return;
    return $2cfd9ea7d82f1add$var$getUniqueHeadingId(nodeContent, headingIds);
}
const $2cfd9ea7d82f1add$var$getText = (node)=>{
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || `[${typeof node.type === 'string' ? node.type : ''}]`;
};
function $2cfd9ea7d82f1add$var$getUniqueHeadingId(baseId, headingIds, counter = 0) {
    if (counter === 0 && !headingIds.has(baseId)) {
        headingIds.add(baseId);
        return baseId;
    } else if (counter !== 0) {
        const headingId = `${baseId}.${counter}`;
        if (!headingIds.has(headingId)) {
            headingIds.add(headingId);
            return headingId;
        }
    }
    return $2cfd9ea7d82f1add$var$getUniqueHeadingId(baseId, headingIds, counter + 1);
}
const $2cfd9ea7d82f1add$var$HEADINGS = new Set([
    'H1',
    'H2',
    'H3',
    'H4',
    'H5',
    'H6'
]);
function* $2cfd9ea7d82f1add$var$getHeadingIds() {
    const editorElement = document.getElementById('ak-editor-textarea');
    const children = editorElement?.getElementsByTagName('*') ?? [];
    const headingIds = new Set();
    const editorTransformer = new (0, $h9yJL.JSONTransformer)();
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($2cfd9ea7d82f1add$var$HEADINGS.has(child.tagName)) {
            const pmNode = child.pmViewDesc?.node;
            if (!pmNode) continue;
            // Copied from TOC
            const adf = editorTransformer.encode(pmNode);
            let adfObject = adf;
            if (typeof adf === 'string') try {
                adfObject = JSON.parse(adf);
            } catch (err) {
            // Swallow the error as ADF format error handling is expected to be done earlier,
            // in the component that renders the entire content
            }
            const headingId = $2cfd9ea7d82f1add$export$dbad71934afee167(adfObject, headingIds);
            if (!headingId) continue;
            yield [
                headingId,
                child,
                pmNode
            ];
        }
    }
}
const $2cfd9ea7d82f1add$export$817005c72dc2688 = ()=>{
    const headingIdToElement = new Map();
    for (const [headingId, child, _] of $2cfd9ea7d82f1add$var$getHeadingIds()){
        headingIdToElement.set(headingId, child);
        // A bit inefficient, but there's sometimes a discrepancy between the hashed ID and the generated ID. The least impactful solution is to just add both.
        headingIdToElement.set(encodeURIComponent(headingId), child);
    }
    return headingIdToElement;
};
const $2cfd9ea7d82f1add$export$e2a78e613c648859 = (node)=>{
    for (const [headingId, _, pmNode] of $2cfd9ea7d82f1add$var$getHeadingIds()){
        if (node === pmNode) return headingId;
    }
    return undefined;
};
module.exports["getHeadingId"] = $2cfd9ea7d82f1add$export$dbad71934afee167;
module.exports["getHeadingIdsToElements"] = $2cfd9ea7d82f1add$export$817005c72dc2688;
module.exports["getHeadingIdForNode"] = $2cfd9ea7d82f1add$export$e2a78e613c648859;

});

parcelRegister("31HPn", function(module, exports) {
const $23fc703b824b091d$export$38c6526d67de94bb = 'xen:macro';
const $23fc703b824b091d$export$8d4b803281599c6a = 'com.atlassian.ecosystem';
const $23fc703b824b091d$export$d7168699755008a = 'com.atlassian.confluence.macro.core';
const $23fc703b824b091d$export$46fc26821adc3495 = 'connectAddon';
const $23fc703b824b091d$export$95077f102dafd025 = 'migratedServerP2Addon';
const $23fc703b824b091d$export$981e47da3e2dfc13 = 'bodiedExtension';
const $23fc703b824b091d$export$4506b39eefa6dc94 = 'multiBodiedExtension';
const $23fc703b824b091d$export$d2cde58d8ae019a9 = 'forge.ui.extension';
const $23fc703b824b091d$export$bf4c163a4c708db1 = 'forgeDocUpdated';
module.exports["MODULE_NAME"] = $23fc703b824b091d$export$38c6526d67de94bb;
module.exports["EXTENSION_NAMESPACE"] = $23fc703b824b091d$export$8d4b803281599c6a;
module.exports["P2_OR_CONNECT_CONFLUENCE_MACRO_EXTENSION_TYPE"] = $23fc703b824b091d$export$d7168699755008a;
module.exports["CONNECT_ADDON_ACTION_SUBJECT"] = $23fc703b824b091d$export$46fc26821adc3495;
module.exports["MIGRATED_SERVER_P2_ADDON_ACTION_SUBJECT"] = $23fc703b824b091d$export$95077f102dafd025;
module.exports["EXTENSION_TYPE_MULTI_BODIED"] = $23fc703b824b091d$export$4506b39eefa6dc94;
module.exports["FORGE_EXTENSION"] = $23fc703b824b091d$export$d2cde58d8ae019a9;
module.exports["FORGE_DOC_UPDATED_EVENT"] = $23fc703b824b091d$export$bf4c163a4c708db1;

});

parcelRegister("liyuV", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");


var $2E7zk = parcelRequire("2E7zk");


var $6mEZ3 = parcelRequire("6mEZ3");


var $7khND = parcelRequire("7khND");


var $eQyFc = parcelRequire("eQyFc");

const $100a3a77b8ac3a59$var$i18n = (0, $aXWIB.defineMessages)({
    displayAs: {
        id: "fabric-extension-lib.toc.displate-as",
        defaultMessage: "Display as"
    },
    separateSectionsBy: {
        id: "fabric-extension-lib.toc.separate-sections",
        defaultMessage: "Separate sections by"
    },
    bulletStyle: {
        id: "fabric-extension-lib.toc.bullet-style",
        defaultMessage: "Bullet style"
    },
    includeHeadingLevelsFrom: {
        id: "fabric-extension-lib.toc.include-heading-levels-from",
        defaultMessage: "Include heading levels from"
    },
    includeHeadingLevelsTo: {
        id: "fabric-extension-lib.toc.include-heading-levels-to",
        defaultMessage: "to"
    },
    includeSectionNumbers: {
        id: "fabric-extension-lib.toc.include-section-numbers",
        defaultMessage: "Include section numbers"
    },
    indentHeadingsLabel: {
        id: "fabric-extension-lib.toc.indent-headings.label",
        defaultMessage: "Indent headings"
    },
    indentHeadingsDescription: {
        id: "fabric-extension-lib.toc.indent-headings.description",
        defaultMessage: "Enter a valid CSS unit value"
    },
    includeHeadingsWithLabel: {
        id: "fabric-extension-lib.toc.include-headings-with.label",
        defaultMessage: "Include headings with:"
    },
    excludeHeadingsWithLabel: {
        id: "fabric-extension-lib.toc.exclude-headings-with.label",
        defaultMessage: "Exclude headings with:"
    },
    headingsWithDescription: {
        id: "fabric-extension-lib.toc.headings-with.description",
        defaultMessage: "Enter one or more keywords separated by | , or any regular expression"
    },
    cssClassNameLabel: {
        id: "fabric-extension-lib.toc.css-class-name.label",
        defaultMessage: "CSS class name"
    },
    cssClassNameDescription: {
        id: "fabric-extension-lib.toc.css-class-name.description",
        defaultMessage: "Enter a valid CSS attribute to customize the <code>&lt;div&gt;</code> surrounding this table of contents"
    },
    excludePDFExport: {
        id: "fabric-extension-lib.toc.exclude-pdf-export",
        defaultMessage: "Exclude PDF export"
    },
    verticalList: {
        id: "fabric-extension-lib.toc.vertical-list",
        defaultMessage: "Vertical list"
    },
    horizontalList: {
        id: "fabric-extension-lib.toc.horizontal-list",
        defaultMessage: "Horizontal list"
    },
    noneBulletStyle: {
        id: "fabric-extension-lib.toc.none-style",
        defaultMessage: "None"
    },
    bulletBulletStyle: {
        id: "fabric-extension-lib.toc.bullet-bullet-style",
        defaultMessage: "Bullet"
    },
    mixedBulletStyle: {
        id: "fabric-extension-lib.toc.mixed-bullet-style",
        defaultMessage: "Mixed"
    },
    circleBulletStyle: {
        id: "fabric-extension-lib.toc.circle-bullet-style",
        defaultMessage: "Circle"
    },
    squareBulletStyle: {
        id: "fabric-extension-lib.toc.square-bullet-style",
        defaultMessage: "Square"
    },
    numberBulletStyle: {
        id: "fabric-extension-lib.toc.number-bullet-style",
        defaultMessage: "Number"
    },
    customBulletStyle: {
        id: "fabric-extension-lib.toc.custom-bullet-style",
        defaultMessage: "Custom"
    },
    bracketSeparator: {
        id: "fabric-extension-lib.toc.bracket-separator",
        defaultMessage: "Bracket"
    },
    braceSeparator: {
        id: "fabric-extension-lib.toc.brace-separator",
        defaultMessage: "Brace"
    },
    pipeSeparator: {
        id: "fabric-extension-lib.toc.pipe-separator",
        defaultMessage: "Pipe"
    },
    basicTab: {
        id: "fabric-extension-lib.toc.basic-tab",
        defaultMessage: "Basic"
    },
    advancedTab: {
        id: "fabric-extension-lib.toc.advanced-tab",
        defaultMessage: "Advanced"
    },
    tocPlaceholder: {
        id: "fabric-extension-lib.toc.placeholder",
        defaultMessage: "A table of contents based on the headings of this content will appear here."
    },
    description: {
        id: "fabric-extension-lib.toc.description",
        defaultMessage: "Create a table of contents based on your content\u2019s headings"
    },
    title: {
        id: "fabric-extension-lib.toc.title",
        defaultMessage: "Table of contents"
    }
});
const $100a3a77b8ac3a59$var$numbers = (0, $aXWIB.defineMessages)({
    one: {
        id: "fabric-extension-lib.one",
        defaultMessage: "1"
    },
    two: {
        id: "fabric-extension-lib.two",
        defaultMessage: "2"
    },
    three: {
        id: "fabric-extension-lib.three",
        defaultMessage: "3"
    },
    four: {
        id: "fabric-extension-lib.four",
        defaultMessage: "4"
    },
    five: {
        id: "fabric-extension-lib.five",
        defaultMessage: "5"
    },
    six: {
        id: "fabric-extension-lib.six",
        defaultMessage: "6"
    }
});
const $100a3a77b8ac3a59$var$convertType = ({ acc: acc, value: value })=>{
    switch(value){
        case 'flat':
            acc['display-as'] = 'horizontal';
            break;
        case 'list':
            acc['display-as'] = 'vertical';
            break;
        case 'horizontal':
            acc['type'] = 'flat';
            break;
        case 'vertical':
            acc['type'] = 'list';
            break;
    }
};
const $100a3a77b8ac3a59$var$convertStyle = ({ transformType: transformType, acc: acc, value: value })=>{
    const key = transformType === 'transformBefore' ? 'bullet-styles' : 'style';
    switch(value){
        /*
      If the value coming in is "mixed," it implies the transformAfter case,
      i.e., the user selected "mixed" in the config panel. In this case, we need to
      set the `style` property to "default," as that's what's actually stored on the
      backend. The `style` property is also what's subsequently used in determining the
      CSS list style of the macro. Conversely, if the value is "default," it implies
      the transformBefore case, so we need to set the `bullet-styles` property to
      "mixed" to indicate that the list style should show mixed in the config panel.
      */ case 'mixed':
            acc['style'] = 'default';
            break;
        case 'default':
            acc['bullet-styles'] = 'mixed';
            break;
        case 'disc':
            acc['bullet-styles'] = 'bullet';
            break;
        case 'bullet':
            acc['style'] = 'disc';
            break;
        case 'circle':
            acc[key] = 'circle';
            break;
        case 'square':
            acc[key] = 'square';
            break;
        case 'none':
            acc[key] = 'none';
            break;
        case 'decimal':
            acc['bullet-styles'] = 'number';
            break;
        case 'number':
            acc['style'] = 'decimal';
            break;
    }
};
const $100a3a77b8ac3a59$var$convertSeparator = ({ transformType: transformType, acc: acc, value: value })=>{
    const key = transformType === 'transformBefore' ? 'separate-sections-by' : 'separator';
    switch(value){
        case 'brackets':
            acc[key] = 'brackets';
            break;
        case 'braces':
            acc[key] = 'braces';
            break;
        case 'pipe':
            acc[key] = 'pipe';
            break;
    }
};
const $100a3a77b8ac3a59$export$538b55b7ba195501 = (parameters)=>{
    if (!parameters || !parameters.macroParams) return {};
    const unwrappedParams = (0, $6mEZ3.unwrapMacroParams)(parameters.macroParams);
    return Object.keys(unwrappedParams).reduce((acc, key)=>{
        const value = unwrappedParams[key];
        switch(key){
            case 'type':
                $100a3a77b8ac3a59$var$convertType({
                    acc: acc,
                    value: value
                });
                break;
            case 'style':
                $100a3a77b8ac3a59$var$convertStyle({
                    transformType: 'transformBefore',
                    acc: acc,
                    value: value
                });
                break;
            case 'separator':
                $100a3a77b8ac3a59$var$convertSeparator({
                    transformType: 'transformBefore',
                    acc: acc,
                    value: value
                });
                break;
            case 'minLevel':
                acc['include-heading-levels-from'] = value;
                break;
            case 'maxLevel':
                acc['include-heading-levels-to'] = value;
                break;
            case 'outline':
                acc['include-section-numbers'] = value === 'true';
                break;
            case 'indent':
                acc['indent-headings-advanced'] = value;
                break;
            case 'include':
                acc['include-headings-advanced'] = value;
                break;
            case 'exclude':
                acc['exclude-headings-advanced'] = value;
                break;
            case 'class':
                acc['css-class-name-advanced'] = value;
                break;
            case 'printable':
                // "printable" technically means "include PDF export", but since changing the terminology
                // to "exclude PDF export" we need to inverse the evaluation
                acc['exclude-pdf-export-advanced'] = value !== 'true';
                break;
        }
        return acc;
    }, {});
};
const $100a3a77b8ac3a59$export$e075bbef54c4ffa = async (parameters)=>{
    const transformedParams = Object.keys(parameters).reduce((acc, key)=>{
        const value = parameters[key];
        switch(key){
            case 'display-as':
                $100a3a77b8ac3a59$var$convertType({
                    acc: acc,
                    value: value
                });
                break;
            case 'bullet-styles':
                $100a3a77b8ac3a59$var$convertStyle({
                    transformType: 'transformAfter',
                    acc: acc,
                    value: value
                });
                break;
            case 'separate-sections-by':
                $100a3a77b8ac3a59$var$convertSeparator({
                    transformType: 'transformAfter',
                    acc: acc,
                    value: value
                });
                break;
            case 'include-heading-levels-from':
                acc['minLevel'] = value;
                break;
            case 'include-heading-levels-to':
                acc['maxLevel'] = value;
                break;
            case 'include-section-numbers':
                acc['outline'] = JSON.stringify(value);
                break;
            case 'indent-headings-advanced':
                acc['indent'] = value;
                break;
            case 'include-headings-advanced':
                acc['include'] = value;
                break;
            case 'exclude-headings-advanced':
                acc['exclude'] = value;
                break;
            case 'css-class-name-advanced':
                acc['class'] = value;
                break;
            case 'exclude-pdf-export-advanced':
                acc['printable'] = value === false ? 'true' : 'false';
                break;
        }
        return acc;
    }, {});
    const wrappedParams = (0, $6mEZ3.wrapMacroParams)(transformedParams);
    return {
        macroParams: wrappedParams
    };
};
const $100a3a77b8ac3a59$export$1eb70cd9e03f9068 = ({ macro: macro, pageContext: pageContext, extensionHandlers: extensionHandlers, openMacroBrowserForInitialConfiguration: openMacroBrowserForInitialConfiguration, macroBrowserConfig: macroBrowserConfig, editorAPI: editorAPI, editorActions: editorActions, createAnalyticsEvent: createAnalyticsEvent, intl: intl, onCompleteCallback: onCompleteCallback, isLivePage: isLivePage })=>{
    const title = intl.formatMessage($100a3a77b8ac3a59$var$i18n.title);
    const description = intl.formatMessage($100a3a77b8ac3a59$var$i18n.description);
    macro.title = title;
    macro.description = description;
    return {
        type: 'com.atlassian.confluence.macro.core',
        key: 'toc',
        title: title,
        description: description,
        icons: (0, $eQyFc.buildIconObject)(macro),
        documentationUrl: 'https://confluence.atlassian.com/display/ConfCloud/Table+of+Contents+Macro',
        modules: {
            quickInsert: (0, $2E7zk.createQuickInsertModule)(macro, pageContext, openMacroBrowserForInitialConfiguration, editorAPI, intl, macroBrowserConfig, editorActions, createAnalyticsEvent, onCompleteCallback, isLivePage),
            nodes: {
                default: {
                    type: 'extension',
                    render: ()=>{
                        const extensionHandler = extensionHandlers['com.atlassian.confluence.macro.core'];
                        return Promise.resolve((extension)=>{
                            if (typeof extensionHandler === 'function') return extensionHandler(extension.node, {
                                references: extension.references
                            });
                            return extensionHandler.render(extension.node, {
                                references: extension.references
                            });
                        });
                    },
                    update: (_, actions)=>{
                        return new Promise(()=>{
                            actions.editInContextPanel($100a3a77b8ac3a59$export$538b55b7ba195501, $100a3a77b8ac3a59$export$e075bbef54c4ffa);
                        });
                    },
                    getFieldsDefinition: (params)=>{
                        // Safely handle null/undefined params by using empty objects as fallback
                        // This ensures the config panel can render even if parameters are corrupted
                        const safeParams = params || {
                            macroParams: {}
                        };
                        const macroParams = safeParams.macroParams || {};
                        const typeValue = macroParams['type']?.value;
                        const includeHeadingsOptions = [
                            {
                                label: intl.formatMessage($100a3a77b8ac3a59$var$numbers.one),
                                value: '1'
                            },
                            {
                                label: intl.formatMessage($100a3a77b8ac3a59$var$numbers.two),
                                value: '2'
                            },
                            {
                                label: intl.formatMessage($100a3a77b8ac3a59$var$numbers.three),
                                value: '3'
                            },
                            {
                                label: intl.formatMessage($100a3a77b8ac3a59$var$numbers.four),
                                value: '4'
                            },
                            {
                                label: intl.formatMessage($100a3a77b8ac3a59$var$numbers.five),
                                value: '5'
                            },
                            {
                                label: intl.formatMessage($100a3a77b8ac3a59$var$numbers.six),
                                value: '6'
                            }
                        ];
                        return Promise.resolve([
                            {
                                type: 'tab-group',
                                name: 'tabGroup',
                                label: 'ToC Tab Group',
                                defaultTab: 'basic',
                                fields: [
                                    {
                                        type: 'tab',
                                        label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.basicTab),
                                        name: 'basic',
                                        fields: [
                                            {
                                                name: 'display-as',
                                                type: 'enum',
                                                style: 'radio',
                                                label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.displayAs),
                                                isMultiple: false,
                                                defaultValue: 'vertical',
                                                items: [
                                                    {
                                                        label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.verticalList),
                                                        value: 'vertical'
                                                    },
                                                    {
                                                        label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.horizontalList),
                                                        value: 'horizontal'
                                                    }
                                                ]
                                            },
                                            ...typeValue === 'flat' ? [
                                                {
                                                    name: 'separate-sections-by',
                                                    label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.separateSectionsBy),
                                                    type: 'enum',
                                                    style: 'select',
                                                    isMultiple: false,
                                                    defaultValue: 'brackets',
                                                    items: [
                                                        {
                                                            label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.bracketSeparator),
                                                            value: 'brackets',
                                                            icon: (0, $7khND.DropdownIcon)({
                                                                icon: (0, $7khND.BracketSVG)
                                                            })
                                                        },
                                                        {
                                                            label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.braceSeparator),
                                                            value: 'braces',
                                                            icon: (0, $7khND.DropdownIcon)({
                                                                icon: (0, $7khND.BraceSVG)
                                                            })
                                                        },
                                                        {
                                                            label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.pipeSeparator),
                                                            value: 'pipe',
                                                            icon: (0, $7khND.DropdownIcon)({
                                                                icon: (0, $7khND.PipeSVG)
                                                            })
                                                        }
                                                    ]
                                                }
                                            ] : [
                                                {
                                                    name: 'bullet-styles',
                                                    label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.bulletStyle),
                                                    type: 'enum',
                                                    style: 'select',
                                                    isMultiple: false,
                                                    defaultValue: !macroParams['style'] && 'mixed',
                                                    placeholder: ![
                                                        'none',
                                                        'mixed',
                                                        'bullet',
                                                        'circle',
                                                        'square',
                                                        'number'
                                                    ].includes(macroParams['style']) && intl.formatMessage($100a3a77b8ac3a59$var$i18n.customBulletStyle),
                                                    items: [
                                                        {
                                                            label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.noneBulletStyle),
                                                            value: 'none',
                                                            icon: null
                                                        },
                                                        {
                                                            label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.mixedBulletStyle),
                                                            value: 'mixed',
                                                            icon: (0, $7khND.DropdownIcon)({
                                                                icon: (0, $7khND.DiscSVG)
                                                            })
                                                        },
                                                        {
                                                            label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.bulletBulletStyle),
                                                            value: 'bullet',
                                                            icon: (0, $7khND.DropdownIcon)({
                                                                icon: (0, $7khND.BulletSVG)
                                                            })
                                                        },
                                                        {
                                                            label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.circleBulletStyle),
                                                            value: 'circle',
                                                            icon: (0, $7khND.DropdownIcon)({
                                                                icon: (0, $7khND.CircleSVG)
                                                            })
                                                        },
                                                        {
                                                            label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.squareBulletStyle),
                                                            value: 'square',
                                                            icon: (0, $7khND.DropdownIcon)({
                                                                icon: (0, $7khND.SquareSVG)
                                                            })
                                                        },
                                                        {
                                                            label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.numberBulletStyle),
                                                            value: 'number',
                                                            icon: (0, $7khND.DropdownIcon)({
                                                                icon: (0, $7khND.NumberedSVG)
                                                            })
                                                        }
                                                    ]
                                                }
                                            ],
                                            {
                                                name: 'include-heading-levels-from',
                                                label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.includeHeadingLevelsFrom),
                                                type: 'enum',
                                                style: 'select',
                                                isMultiple: false,
                                                defaultValue: '1',
                                                items: includeHeadingsOptions
                                            },
                                            {
                                                name: 'include-heading-levels-to',
                                                label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.includeHeadingLevelsTo),
                                                type: 'enum',
                                                style: 'select',
                                                isMultiple: false,
                                                defaultValue: '6',
                                                items: includeHeadingsOptions
                                            },
                                            {
                                                name: 'include-section-numbers',
                                                type: 'boolean',
                                                style: 'checkbox',
                                                label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.includeSectionNumbers),
                                                defaultValue: false
                                            }
                                        ]
                                    },
                                    {
                                        type: 'tab',
                                        label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.advancedTab),
                                        name: 'advanced',
                                        fields: [
                                            {
                                                name: 'indent-headings-advanced',
                                                label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.indentHeadingsLabel),
                                                isRequired: false,
                                                description: intl.formatMessage($100a3a77b8ac3a59$var$i18n.indentHeadingsDescription),
                                                type: 'string'
                                            },
                                            {
                                                name: 'include-headings-advanced',
                                                label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.includeHeadingsWithLabel),
                                                isRequired: false,
                                                description: intl.formatMessage($100a3a77b8ac3a59$var$i18n.headingsWithDescription),
                                                type: 'string'
                                            },
                                            {
                                                name: 'exclude-headings-advanced',
                                                label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.excludeHeadingsWithLabel),
                                                isRequired: false,
                                                description: intl.formatMessage($100a3a77b8ac3a59$var$i18n.headingsWithDescription),
                                                type: 'string'
                                            },
                                            {
                                                name: 'css-class-name-advanced',
                                                label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.cssClassNameLabel),
                                                isRequired: false,
                                                description: intl.formatMessage($100a3a77b8ac3a59$var$i18n.cssClassNameDescription),
                                                type: 'string'
                                            },
                                            {
                                                name: 'exclude-pdf-export-advanced',
                                                label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.excludePDFExport),
                                                defaultValue: false,
                                                style: 'checkbox',
                                                type: 'boolean'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]);
                    }
                }
            }
        }
    };
};
module.exports["tableOfContentsExtension"] = $100a3a77b8ac3a59$export$1eb70cd9e03f9068;

});

parcelRegister("6i41U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8x1Q3 = parcelRequire("8x1Q3");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $77954d5459a690cb$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $42omo.useContext)((0, $8x1Q3.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $77954d5459a690cb$export$2e2bcd8739ae039 = $77954d5459a690cb$var$useRouterLink;
module.exports["default"] = $77954d5459a690cb$export$2e2bcd8739ae039;

});

parcelRegister("8x1Q3", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $830764d8fffe9f5a$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $42omo.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $830764d8fffe9f5a$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($830764d8fffe9f5a$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $830764d8fffe9f5a$export$2e2bcd8739ae039 = $830764d8fffe9f5a$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $830764d8fffe9f5a$export$2931e0ee690eee88;

});

parcelRegister("aJPUt", function(module, exports) {
var $bcb0fe1d423eb4f4$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 45000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});
module.exports["ExperienceTimeout"] = $bcb0fe1d423eb4f4$export$5e180a90f8d3e374;

});

parcelRegister("iS5Ay", function(module, exports) {

var $4HDYO = parcelRequire("4HDYO");


var $6fil2 = parcelRequire("6fil2");


var $1RY07 = parcelRequire("1RY07");


var $GLgaM = parcelRequire("GLgaM");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");


var $bjeS8 = parcelRequire("bjeS8");

async function $7002390fd45cd24e$export$ca7e5505c9b1be25({ url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, fetchPolicy: fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'none', skip: skip = false, onError: onError, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, ignoreNoNetworkError: ignoreNoNetworkError, transformError: transformError }) {
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    const fetchData = async ()=>{
        try {
            const json = await (0, $GLgaM.fetchResponse)({
                url: url,
                method: method,
                body: body,
                headers: headers,
                credentials: credentials,
                parseResponseOnSuccess: parseResponseOnSuccess,
                parseResponseOnError: parseResponseOnError
            }, variables);
            return await parseResult(json, variables);
        } catch (error) {
            if (ignoreNoNetworkError && (0, $6fil2.containsNetworkError)(error)) return undefined;
            throw error;
        }
    };
    const storeInstance = (0, $4HDYO.defaultRegistry).getStore((0, $7ji4X.queryStateStore));
    const getCachedData = ()=>{
        const queryState = storeInstance.storeState.getState();
        return queryState[key]?.data;
    };
    const setCachedData = (data)=>{
        storeInstance.actions.setQueryState(key, {
            data: data,
            loading: false,
            error: undefined,
            called: true
        });
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $1RY07.apolloCompatibleQuery)({
        fetchData: fetchData,
        fetchPolicy: fetchPolicy,
        errorPolicy: errorPolicy,
        skip: skip,
        getCachedData: getCachedData,
        setCachedData: setCachedData,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalQuery"] = $7002390fd45cd24e$export$ca7e5505c9b1be25;

});

parcelRegister("aBfpe", function(module, exports) {
/**
 * https://www.iana.org/assignments/media-types/media-types.xhtml
 */ var $c27c52d002752847$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $c27c52d002752847$export$483c11740a902fcd;

});

parcelRegister("8Utl8", function(module, exports) {
/* renderTocDirect.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $auNCB = parcelRequire("auNCB");


var $79mJ9 = parcelRequire("79mJ9");


var $d3Yd3 = parcelRequire("d3Yd3");

const $be5130bdb4a81bdd$export$b66a2f2b47bf6353 = 'toc-empty-item';
const $be5130bdb4a81bdd$var$styles = {
    link: "_11c81d4k"
};
function $be5130bdb4a81bdd$var$normalizeHeadings(elements) {
    const minLevel = elements.reduce((min, el)=>Math.min(min, el?.attrs?.level ?? 6), Infinity);
    if (elements[0]?.attrs?.level === minLevel) return elements;
    return [
        {
            type: 'toc',
            attrs: {
                level: minLevel
            },
            content: [
                {
                    text: $be5130bdb4a81bdd$export$b66a2f2b47bf6353,
                    type: 'string'
                }
            ]
        },
        ...elements
    ];
}
const $be5130bdb4a81bdd$export$36615f8ab4c6a228 = (headerElements, renderer)=>{
    if (headerElements.length === 0) return renderer.mergeItems([]);
    const headings = $be5130bdb4a81bdd$var$normalizeHeadings(headerElements);
    const stack = [];
    const rootResults = [];
    const counters = [];
    function close() {
        const frame = stack.pop();
        const children = renderer.mergeItems(frame.childResults);
        const result = renderer.renderItem(frame.heading, stack.length, children);
        const parent = stack.at(-1);
        if (parent) parent.childResults.push(result);
        else rootResults.push(result);
    }
    for (const entity of headings){
        const level = entity.attrs?.level ?? 1;
        while(stack.length > 0 && stack[stack.length - 1].level >= level)close();
        if (counters.length <= stack.length) counters.push(0);
        counters[stack.length]++;
        counters.length = stack.length + 1;
        const outline = counters.map(String);
        const isEmpty = entity.content?.[0]?.text === $be5130bdb4a81bdd$export$b66a2f2b47bf6353;
        const heading = {
            content: entity.content ?? [],
            level: level,
            id: isEmpty ? $be5130bdb4a81bdd$export$b66a2f2b47bf6353 : entity.attrs?.id ?? '',
            outline: outline
        };
        stack.push({
            level: level,
            heading: heading,
            childResults: []
        });
    }
    while(stack.length > 0)close();
    return renderer.mergeItems(rootResults);
};
function $be5130bdb4a81bdd$var$renderContent(content, cloudId, userId) {
    const nodes = content.filter(Boolean);
    if (nodes.length === 0) return null;
    if (nodes.every((n)=>n.type === 'text' || n.type === 'hardBreak')) return nodes.map((n)=>n.type === 'hardBreak' ? '' : n.text ?? '').join('');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $79mJ9.MiniRenderer), {
        adfEntities: content,
        cloudId: cloudId,
        userId: userId
    });
}
function $be5130bdb4a81bdd$var$renderLink(heading, outline, cloudId, userId) {
    const outlineStr = heading.outline.join('.');
    const href = `#${encodeURIComponent(heading.id)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
        testId: "toc-item-body",
        "data-outline": outlineStr,
        href: href,
        onClick: ()=>(0, $d3Yd3.scrollToHeader)(href),
        className: (0, $gMc0m.default)([
            $be5130bdb4a81bdd$var$styles.link
        ])
    }, outline === 'true' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, outlineStr, " "), $be5130bdb4a81bdd$var$renderContent(heading.content, cloudId, userId));
}
function $be5130bdb4a81bdd$var$renderFlatToc(headerelements, outline, separators, cloudId, userId) {
    const flatItems = $be5130bdb4a81bdd$export$36615f8ab4c6a228(headerelements, {
        renderItem: (heading, _depth, children)=>{
            if (heading.id === $be5130bdb4a81bdd$export$b66a2f2b47bf6353) return children ?? [];
            return [
                $be5130bdb4a81bdd$var$renderLink(heading, outline, cloudId, userId),
                ...children ?? []
            ];
        },
        mergeItems: (merged)=>merged.flat()
    });
    if (flatItems.length === 0) return null;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": "flat-style-toc-item-container",
        className: "toc-item-container"
    }, flatItems.map((item, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), {
            key: idx
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            className: "toc-separator"
        }, idx === 0 ? separators[0] : separators[1]), item)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: "toc-separator"
    }, separators[2])));
}
function $be5130bdb4a81bdd$var$renderListToc(headerelements, outline, cssliststyle, csslistindent, cloudId, userId) {
    return $be5130bdb4a81bdd$export$36615f8ab4c6a228(headerelements, {
        renderItem: (heading, _depth, children)=>{
            const isEmpty = heading.id === $be5130bdb4a81bdd$export$b66a2f2b47bf6353;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", {
                key: heading.outline.join('.'),
                "data-testid": "list-style-toc-item-container",
                style: {
                    listStyle: isEmpty ? 'none' : cssliststyle ?? 'default'
                }
            }, !isEmpty && $be5130bdb4a81bdd$var$renderLink(heading, outline, cloudId, userId), children);
        },
        mergeItems: (listItems)=>{
            if (listItems.length === 0) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ul", {
                "data-testid": "list-style-toc-level-container",
                style: {
                    paddingLeft: csslistindent
                }
            }, listItems);
        }
    });
}
const $be5130bdb4a81bdd$export$dcb83f9ad409c737 = (tocOptions, separators, cloudId, userId)=>{
    const { headerelements: headerelements, structure: structure, outline: outline, cssliststyle: cssliststyle, csslistindent: csslistindent } = tocOptions;
    if (!headerelements?.length) return null;
    if (structure === 'flat') return $be5130bdb4a81bdd$var$renderFlatToc(headerelements, outline, separators, cloudId, userId);
    return $be5130bdb4a81bdd$var$renderListToc(headerelements, outline, cssliststyle, csslistindent, cloudId, userId);
};
module.exports["EmptyTocItem"] = $be5130bdb4a81bdd$export$b66a2f2b47bf6353;
module.exports["renderReducedToc"] = $be5130bdb4a81bdd$export$dcb83f9ad409c737;

});

parcelRegister("79mJ9", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $iXCQx = parcelRequire("iXCQx");


var $g2dpd = parcelRequire("g2dpd");

const $6b94f1cb3b6ea4db$export$c28721872d45d644 = (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { adfEntities: adfEntities, cloudId: cloudId, userId: userId } = t0;
    let t1;
    if ($[0] !== adfEntities || $[1] !== cloudId || $[2] !== userId) {
        let t2;
        if ($[4] !== cloudId || $[5] !== userId) {
            t2 = (el, idx)=>{
                switch(el?.type){
                    case "date":
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g2dpd.DateLoader), {
                            timestamp: el?.attrs?.timestamp
                        });
                    case "emoji":
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g2dpd.EmojiLoader), {
                            id: el?.attrs?.id,
                            shortName: el?.attrs?.shortName,
                            cloudId: cloudId,
                            userId: userId
                        });
                    case "mention":
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g2dpd.MentionLoader), {
                            name: el?.attrs?.text,
                            isUserSelf: el?.attrs?.id === userId
                        });
                    case "status":
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g2dpd.StatusLoader), {
                            text: el?.attrs?.text,
                            color: el?.attrs?.color,
                            isBold: el?.attrs?.style === "bold"
                        });
                    default:
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                            as: "span",
                            color: "inherit",
                            size: "large",
                            key: idx
                        }, el?.text || el?.attrs?.text || el?.attrs?.__confluenceMetadata?.contentTitle || "");
                }
            };
            $[4] = cloudId;
            $[5] = userId;
            $[6] = t2;
        } else t2 = $[6];
        t1 = adfEntities.map(t2);
        $[0] = adfEntities;
        $[1] = cloudId;
        $[2] = userId;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[7] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            as: "span",
            color: "inherit",
            size: "large"
        }, t1);
        $[7] = t1;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
};
module.exports["MiniRenderer"] = $6b94f1cb3b6ea4db$export$c28721872d45d644;

});

parcelRegister("d3Yd3", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");

const $1593092db348217b$export$6a9dfcea43015ca7 = (id)=>{
    if (!id) return;
    const escapedId = id.replace(/[.:;*+?^$!@$^&~%{}()=/|[\]\\]/g, '\\$&');
    const pmodeContent = document.querySelector(`#presenter-mode-container ${escapedId}`);
    if (pmodeContent) pmodeContent.scrollIntoView();
    if ((0, $6mKj3.expValEquals)('confluence_toc_nav_a11y', 'isEnabled', true)) {
        // Extract the id from the href (remove the # prefix if present)
        const targetId = id.startsWith('#') ? id.substring(1) : id;
        const decodedId = decodeURIComponent(targetId);
        // For normal page view, find the element by id
        const targetElement = document.getElementById(decodedId);
        if (targetElement) // Move focus to the target element for screen reader accessibility
        targetElement.focus();
    }
};
module.exports["scrollToHeader"] = $1593092db348217b$export$6a9dfcea43015ca7;

});

parcelRegister("g2dpd", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $151bbc40c0c4a388$export$25f69473ce9bec3b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Sb9EH",
    name: 'DateLoader',
    loader: async ()=>(await (parcelRequire("4CRRu"))).DateComponent
});

const $151bbc40c0c4a388$export$a6d57304049a7a43 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zhXsC",
    name: 'EmojiLoader',
    loader: async ()=>(await (parcelRequire("bCNu1"))).EmojiComponent
});

const $151bbc40c0c4a388$export$d85b1a715d2d313e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "4AxQj",
    name: 'EmojiLoader',
    loader: async ()=>(await (parcelRequire("aaCOu"))).MentionComponent
});

const $151bbc40c0c4a388$export$498fc322979ddd04 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "LHr7Y",
    name: 'StatusLoader',
    loader: async ()=>(await (parcelRequire("13jdz"))).StatusComponent
});
module.exports["DateLoader"] = $151bbc40c0c4a388$export$25f69473ce9bec3b;
module.exports["EmojiLoader"] = $151bbc40c0c4a388$export$a6d57304049a7a43;
module.exports["MentionLoader"] = $151bbc40c0c4a388$export$d85b1a715d2d313e;
module.exports["StatusLoader"] = $151bbc40c0c4a388$export$498fc322979ddd04;

});


//# sourceMappingURL=TableOfContents.fad6297e.js.map
